/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { ASSIGN_APP_LOCATION, ACTIVE_BUTTON_INDEX } from './types';
import { Location } from '../../models/Locations/Locations';

export const assignAppLocation = (location: Location | null) => {
  return {
    type: ASSIGN_APP_LOCATION,
    location
  };
};
export const setActiveButtonIndex = (index:any) => {
  return {
    type: ACTIVE_BUTTON_INDEX,
    index
  };
};